import React, { useState } from "react";
import "../styles/carousel.css";
import img1 from "../assets/images/carrousel/consultorio3.jpg";

const Carrossel = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  return (
    <section id="home">
  <div className="carousel-container">
    <div className="carousel">
      <div className="carousel-track">
        <img src={img1} alt="Slide principal" className="carousel-image" />
        <div className="carousel-content">
        <h1>Psicólogo Marcelo Martins</h1>
        <h2>Psicólogo licenciado</h2>
        <h2>CRP 06/123896</h2>
        <br></br>
        <a
          href="https://wa.me/551198835125?text=Ol%C3%A1!%20Vim%20atrav%C3%A9s%20do%20site%20e%20gostaria%20de%20mais%20informa%C3%A7%C3%B5es."
          target="_blank"
          rel="noopener noreferrer"
          className="cta-button"
        >
          Agendar Sessão
        </a>

        <br/>
        <br/>
        <br/>
          <h9>Acolhimento emocional e psicanálise para sua saúde mental.</h9>
          
        <br/>
          <h9>Atendimentos presenciais e online, pensados para o seu conforto e bem-estar.</h9>
          <br />
          
          <br/>
          <br></br>
          
        </div>
        
      </div>
      
      {/* Depoimentos SOBRE A IMAGEM
      <div className="testimonial-cards">
        <div className="testimonial-card">
          <span className="testimonial-icon">💬</span>
          <p>"Me senti acolhido desde a primeira sessão."</p>
        </div>
        <div className="testimonial-card">
          <span className="testimonial-icon">😊</span>
          <p>"Minha ansiedade melhorou muito, recomendo!"</p>
        </div>
        <div className="testimonial-card">
          <span className="testimonial-icon">🌿</span>
          <p>"Espaço tranquilo e profissionalismo incrível."</p>
        </div>
      </div> */}
    </div>
  </div>
</section>

  );
};

export default Carrossel;
